import { Box, Grid, Typography } from '@mui/material'
import SocialMediaLinks from '../components/SocialMediaLinks'
import ContactForm from "../components/ContactForm"

const Contact = () => {
  return (
    <Grid container id="contact" columnSpacing={{xs: 0, md: 4}} rowSpacing={{xs: 8, md: 0}} sx={{
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      py: "88px",
      alignItems: "center"
    }}>
      <Grid item xs={12} md={6} sx={{px: {sx: "10vw", md: "none"}}}>
        <Typography variant="h4" sx={{textAlign: "left", marginBottom: "2rem"}}>
          Contact Us.
        </Typography>
        <Box sx={{paddingLeft:{xs: "2rem", sm: "3rem", md: "4rem"}, marginBottom: "4rem"}}>
          <Typography variant="subtitle1" sx={{marginBottom: "2rem"}}>
            CyberBadge is a powerful tool for anyone looking to grab attention and make a statement at their next event or party
          </Typography>
          <Typography variant="subtitle1">
            With its lightweight design, easy-to-use application, and eye-catching LED display, it is the perfect addition to any event or marketing campaign
          </Typography>
        </Box>
        <Box sx={{paddingLeft:{xs: "1rem", sm: "1.5rem", md: "2rem"}}}>
          <SocialMediaLinks
            instagramLink="https://www.instagram.com/cyberbadge"
            linkedInLink="https://www.linkedin.com/in/bogdan-panov"
            placeLink="https://hsp.sh"
            playLink="https://play.google.com/store/apps/details?id=com.DefaultCompany.LedDisplayApplication"
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6} alignItems="flex-start">
        <ContactForm />
      </Grid>
    </Grid>
  )
}

export default Contact